import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { orderSearchModel } from '../models/orderSearchModel';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private _http: HttpClient) { }

  getOrderStatuses(searchCriteria: orderSearchModel): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'Order/PostSearchCustomerOrders', searchCriteria);
  }

  getOrderCancelReasons(): Observable<any> {
    return this._http.get<any>(environment.config.BASE_API_URL + 'Order/GetOrderCancelReason');
  }

  changeOrderStatusByAdmin(orderNo: string, cancelSource?: string, orderOperation?: string, CancelReasonId?: number): Observable<any> {
    // const params = new HttpParams()
    //       .set('orderNo', orderNo)
    //       .set('cancelReasonId', CancelReasonId)
    //       .set('cancelSource', cancelSource)
    //       .set('orderOperation', orderOperation);
    return this._http.get<any>(`${environment.config.BASE_API_URL}Order/GetCancelOrderByAdmin?orderNo=${orderNo}&cancelReasonId=${CancelReasonId}&cancelSource=${cancelSource}&orderOperation=${orderOperation}`);

  }

}
